import h from "./html";
import Db from "./db";

export default function Connections({ db }: { db: Db }) {
  const incoming = db.query(
    /* sql */ `
      SELECT
        user.user_id,
        user.name,
        user.email
      FROM
        me
        INNER JOIN user_connection AS forward ON forward.follower_id = me.user_id
        LEFT JOIN user ON user.user_id = forward.user_id
        LEFT JOIN user_connection AS reverse ON forward.follower_id = reverse.user_id
        AND forward.user_id = reverse.follower_id
      WHERE
        reverse.user_id IS NULL
    `,
    ["userId", "name", "email"],
    [],
  );
  const connections = db.query(
    /* sql */ `
      SELECT
        user.user_id,
        user.name,
        user.email
      FROM
        me
        INNER JOIN user_connection AS forward ON forward.follower_id = me.user_id
        LEFT JOIN user ON user.user_id = forward.user_id
        INNER JOIN user_connection AS reverse ON forward.follower_id = reverse.user_id
        AND forward.user_id = reverse.follower_id
    `,
    ["userId", "name", "email"],
    [],
  );
  const outgoing = db.query(
    /* sql */ `
      SELECT
        user.email
      FROM
        me
        INNER JOIN user_connection AS forward ON forward.user_id = me.user_id
        LEFT JOIN user ON user.user_id = forward.follower_id
        LEFT JOIN user_connection AS reverse ON forward.follower_id = reverse.user_id
        AND forward.user_id = reverse.follower_id
      WHERE
        reverse.user_id IS NULL
    `,
    ["email"],
    [],
  );

  return (
    <div className="flex flex-col">
      {() => {
        const incomingVal = incoming.val;
        const outgoingVal = outgoing.val;
        return incomingVal instanceof Array &&
          outgoingVal instanceof Array &&
          (incomingVal.length > 0 || outgoingVal.length > 0) ? (
          <div>
            <h2 className="text-xl mb-2 font-bold">Pending invitations</h2>
            <div className="mb-2">
              {() => {
                return (
                  <ul className="list-disc list-inside">
                    {incomingVal.map((user) => (
                      <li className="">
                        <strong>
                          {user.name} ({user.email})
                        </strong>{" "}
                        wants to connect with you.
                        <span className="pl-2 inline">
                          <a
                            className="text-blue-600 underline"
                            href="javascript:void(0)"
                          >
                            accept
                          </a>{" "}
                          |{" "}
                          <a
                            className="text-red-600 underline"
                            href="javascript:void(0)"
                          >
                            reject
                          </a>
                        </span>
                      </li>
                    ))}
                  </ul>
                );
              }}
              {() => {
                return (
                  <ul className="list-disc list-inside">
                    {outgoingVal.map((user) => (
                      <li className="">
                        <span className="italic">
                          Pending response from {user.email}
                        </span>
                        <span className="pl-2 inline">
                          <a
                            className="text-blue-600 underline"
                            href="javascript:void(0)"
                            onclick={(ev) => {
                              ev.preventDefault();
                              db.disconnect(user.email as string);
                            }}
                          >
                            cancel
                          </a>{" "}
                        </span>
                      </li>
                    ))}
                  </ul>
                );
              }}
            </div>
          </div>
        ) : (
          ""
        );
      }}
      <h2 className="text-xl mb-2 font-bold">Connections</h2>
      <div className="mb-2">
        {() => {
          if (connections.val === "loading") {
            return "";
          } else if (connections.val === "error") {
            return "Something went wrong.";
          } else if (connections.val.length === 0) {
            return "You are not connected to other users on this app.";
          } else {
            return (
              <ul className="list-disc list-inside">
                {connections.val.map((user) => (
                  <li className="">
                    {user.name} ({user.email})
                  </li>
                ))}
              </ul>
            );
          }
        }}
      </div>
      <form
        className="mb-2 flex flex-row"
        onsubmit={async (ev) => {
          ev.preventDefault();
          const form = ev.target as HTMLFormElement;
          const formData = new FormData(form);
          const email = formData.get("invite") as string;
          db.connect(email);
          (
            form.querySelector('input[name="invite"]') as HTMLInputElement
          ).value = "";
        }}
      >
        <input
          type="email"
          name="invite"
          className="border-2 rounded-l-md h-8 border-r-0 px-2"
          placeholder={`${new Date().toLocaleDateString(undefined, { month: "long" }).toLowerCase()}@example.com`}
        />
        <button className="bg-blue-500 hover:bg-blue-300 text-blue-50 border-blue-400 border-2 rounded-r-md px-8 disabled:bg-fairy-300 mb-2 w-32 h-8">
          Invite
        </button>
      </form>
    </div>
  );
}
